import { kurbanOpsCards } from '@/mocks/homeData';

export default function KurbanOperationsSection() {
  return (
    <section id="kurban-operasyon" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 rounded-full text-xs font-semibold mb-4">
            Kurban Operasyon Yönetimi
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-4">
            Dijital kurban kesim sıramatiği ve operasyonu ile Bayram yoğunluğunu yönetin.
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-3xl mx-auto">
            Kurban döneminde satış, hisse, ödeme, kesim sırası, taşıma ve teslimat süreçleri aynı anda yönetilmek zorundadır. CiftlikWeb, kurbanlık satış ve hisse takip programını Excel ve kağıt defter yerine tek merkezde, uygulama indirmeden cepten yönetmenizi sağlar.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {kurbanOpsCards.map((card, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl p-6 border border-background-200/70 hover:border-accent-200/50 transition-all duration-300 group flex flex-col"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center bg-accent-50 rounded-lg mb-5 group-hover:bg-accent-100 transition-colors duration-300">
                <i className={`${card.icon} text-accent-500 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading font-semibold text-base md:text-lg text-foreground-950 mb-2.5">
                {card.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {card.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="#demo"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#demo')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-md hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Demo Talep Et
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
